// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__6T82F","actionGroup":"Pagination_actionGroup__S07nj","sizing":"Pagination_sizing__GPd2k"};